module.exports = __webpack_public_path__ + "static/media/bostonsdeals.c3b040d7.PNG";